import { render, staticRenderFns } from "./Egitim-Video.vue?vue&type=template&id=650c901b&scoped=true&"
import script from "./Egitim-Video.vue?vue&type=script&lang=js&"
export * from "./Egitim-Video.vue?vue&type=script&lang=js&"
import style0 from "./Egitim-Video.vue?vue&type=style&index=0&id=650c901b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c901b",
  null
  
)

export default component.exports